import React from 'react';
import { Badge, Grid, IconButton, Tooltip, useMediaQuery } from '@mui/material';

import useSettings from '../hooks/useSettings';
import Icon from '../Icon';
import FilterDialog from './FilterDialog';
import QueryBuilderDialog from './QueryBuilderDialog';

interface FilterButtonsProps {
	/** The module name */
	module: string;
	/** The filters props */
	filterProps: any;
}

export default function FilterButtons({ module, filterProps }: FilterButtonsProps) {
	const { t } = useSettings();
	const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

	const {
		defaultFilters,
		currentFilters,
		setCurrentFilters,
		defaultQuery,
		currentQuery,
		currentTree,
		queryConfig,
		handleFilterChange,
		handleFiltersApply,
		handleFiltersClear,
		handleQueryChange,
		handleQueryApply,
		handleQueryClear
	} = filterProps;

	const [openFilterDialog, setOpenFilterDialog] = React.useState(false);
	const [openQueryBuilder, setOpenQueryBuilder] = React.useState(false);

	function clearFilters() {
		handleFiltersClear();
		handleQueryClear();
	}

	return (
		<Grid container spacing={1} alignItems="center">
			<Grid>
				<Tooltip title={t('FILTER_BUTTON')} arrow>
					<IconButton size="small" onClick={() => setOpenFilterDialog(true)}>
						<Badge color="secondary" variant="dot" invisible={currentFilters.length === 0}>
							<Icon icon="filter" />
						</Badge>
					</IconButton>
				</Tooltip>
				<FilterDialog
					open={openFilterDialog}
					closeDialog={() => setOpenFilterDialog(false)}
					module={module}
					defaultFilters={defaultFilters}
					currentFilters={currentFilters}
					setCurrentFilters={setCurrentFilters}
					handleFilterChange={handleFilterChange}
					handleFiltersApply={handleFiltersApply}
				/>
			</Grid>
			{!isMobile && (
				<Grid>
					<Tooltip title={t('FILTER_QUERY_BUILDER_BUTTON')} arrow>
						<IconButton size="small" onClick={() => setOpenQueryBuilder(true)}>
							<Badge color="secondary" variant="dot" invisible={!currentQuery}>
								<Icon icon="file-tree" />
							</Badge>
						</IconButton>
					</Tooltip>
					<QueryBuilderDialog
						open={openQueryBuilder}
						closeDialog={() => setOpenQueryBuilder(false)}
						currentQuery={currentQuery || defaultQuery}
						currentTree={currentTree}
						queryConfig={queryConfig}
						handleQueryClear={handleQueryClear}
						handleQueryChange={handleQueryChange}
						handleQueryApply={handleQueryApply}
					/>
				</Grid>
			)}
			<Grid>
				{currentFilters.length > 0 || currentQuery ? (
					<Tooltip title={t('FILTER_CLEAR_BUTTON')} arrow>
						<IconButton size="small" onClick={clearFilters}>
							<Icon icon="filter-off" />
						</IconButton>
					</Tooltip>
				) : (
					<IconButton size="small" disabled>
						<Icon icon="filter-off" />
					</IconButton>
				)}
			</Grid>
		</Grid>
	);
}
